(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom__image-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('community-image-carousel')) {
    customElements.define('community-image-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.media = this.querySelector('.image-carousel__media');
        if (!this.media) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.previous = this.querySelector('[data-carousel-direction="-1"]');
        this.next = this.querySelector('[data-carousel-direction="1"]');

        this.querySelectorAll('[data-carousel-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            const item = this.querySelector('.image-carousel__item');
            const distance = item ? item.offsetWidth : this.media.clientWidth;
            const direction = Number(button.dataset.carouselDirection);
            const rtl = getComputedStyle(this.media).direction === 'rtl' ? -1 : 1;
            this.media.scrollBy({
              left: distance * direction * rtl,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }, { signal });
        });

        this.media.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.media);
        this.updateControls();
        this.setupPhotoMotion(signal);
      }

      setupPhotoMotion(signal) {
        this.photoStates = new Map();
        const photos = this.querySelectorAll('[data-photo-motion]');
        if (!photos.length) return;
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.photoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.photoStates.get(entry.target).visible = entry.isIntersecting;
          });
          this.updatePhotoMotion();
        }, { threshold: 0.25 });

        photos.forEach(photo => {
          const button = photo.querySelector('[data-photo-toggle]');
          const images = [...photo.querySelectorAll('.image-carousel__image')];
          const state = { button, ready: false, visible: false, paused: false };
          this.photoStates.set(photo, state);
          const checkReady = () => {
            state.ready = images.every(image => image.complete && image.naturalWidth > 0);
            this.updatePhotoMotion();
          };
          images.forEach(image => image.addEventListener('load', checkReady, { signal }));
          button.addEventListener('click', () => {
            state.paused = !state.paused;
            this.updatePhotoMotion();
          }, { signal });
          checkReady();
          this.photoObserver.observe(photo);
        });

        document.addEventListener('visibilitychange', () => this.updatePhotoMotion(), { signal });
        this.motionPreference.addEventListener('change', () => this.updatePhotoMotion(), { signal });
      }

      updatePhotoMotion() {
        this.photoStates.forEach((state, photo) => {
          const reducedMotion = this.motionPreference.matches;
          photo.toggleAttribute('data-photo-ready', state.ready);
          photo.dataset.photoPlaying = String(state.ready && state.visible && !state.paused && !reducedMotion && !document.hidden);
          state.button.hidden = !state.ready || reducedMotion;
          state.button.setAttribute('aria-label', state.paused ? state.button.dataset.playLabel : state.button.dataset.pauseLabel);
          state.button.querySelector('[data-photo-play]').hidden = !state.paused;
          state.button.querySelector('[data-photo-pause]').hidden = state.paused;
        });
      }

      updateControls() {
        const position = Math.abs(this.media.scrollLeft);
        const maximum = this.media.scrollWidth - this.media.clientWidth;
        if (this.previous) this.previous.disabled = position <= 2;
        if (this.next) this.next.disabled = position >= maximum - 2;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.photoObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom__meet-artists-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('artist-discovery-carousel')) {
    customElements.define('artist-discovery-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.rail = this.querySelector('.meet-artists-home__rail');
        if (!this.rail) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.controls = this.querySelector('.meet-artists-home__controls');
        this.previous = this.querySelector('[data-artist-direction="-1"]');
        this.next = this.querySelector('[data-artist-direction="1"]');

        this.querySelectorAll('[data-artist-direction]').forEach(button => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const card = this.querySelector('.meet-artists-home__card');
            const style = getComputedStyle(this.rail);
            const gap = parseFloat(style.columnGap) || 0;
            const distance = card ? card.offsetWidth + gap : this.rail.clientWidth;
            const direction = Number(button.dataset.artistDirection);
            this.rail.scrollBy({
              left: distance * direction * (style.direction === 'rtl' ? -1 : 1),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }, { signal });
        });

        this.rail.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.rail);
        const card = this.querySelector('.meet-artists-home__card');
        if (card) this.resizeObserver.observe(card);
        this.updateControls();
      }

      updateControls() {
        if (!this.controller) return;
        const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const direction = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
        const position = Math.min(maximum, Math.max(0, this.rail.scrollLeft * direction));
        if (this.previous) this.previous.disabled = position <= 2;
        if (this.next) this.next.disabled = position >= maximum - 2;
        if (this.controls) this.controls.hidden = maximum <= 2;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom__sale-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('swapwear-sale-banner')) {
    customElements.define('swapwear-sale-banner', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('[data-sale-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-sale-go-to]'));
        this.pauseButton = this.querySelector('[data-sale-pause]');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.currentIndex = 0;
        this.paused = false;
        this.focusPaused = this.contains(document.activeElement);
        this.inView = !('IntersectionObserver' in window);
        this.toggleAttribute('data-paused', false);

        this.addEventListener('click', event => {
          const dot = event.target.closest('[data-sale-go-to]');
          if (dot) {
            this.currentIndex = Number(dot.dataset.saleGoTo);
            this.paused = true;
            this.updateSlides();
          } else if (event.target.closest('[data-sale-pause]')) {
            this.paused = !this.paused;
            if (!this.paused) this.focusPaused = false;
          } else {
            return;
          }
          this.updatePlaybackControl();
          this.syncPlayback();
        }, options);

        this.addEventListener('focusin', () => {
          this.focusPaused = true;
          this.syncPlayback();
        }, options);
        this.addEventListener('focusout', event => {
          this.focusPaused = this.contains(event.relatedTarget);
          this.syncPlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.motionQuery.addEventListener('change', () => this.syncPlayback(), options);
        this.mobileQuery.addEventListener('change', () => {
          this.currentIndex = 0;
          this.updateSlides();
          this.syncPlayback();
        }, options);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.syncPlayback();
          }, { threshold: 0.1 });
          this.observer.observe(this);
        }

        this.updateSlides();
        this.updatePlaybackControl();
        this.setAttribute('data-carousel-ready', '');
        this.syncPlayback();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.controller.abort();
        this.observer?.disconnect();
        this.removeAttribute('data-carousel-ready');
        this.slides.forEach(slide => {
          slide.removeAttribute('aria-hidden');
          slide.inert = false;
        });
      }

      updateSlides() {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          const hidden = this.mobileQuery.matches && !active;
          slide.classList.toggle('is-active', active);
          slide.inert = hidden;
          if (hidden) slide.setAttribute('aria-hidden', 'true');
          else slide.removeAttribute('aria-hidden');
          this.dots[index].setAttribute('aria-pressed', String(active));
        });
      }

      updatePlaybackControl() {
        this.toggleAttribute('data-paused', this.paused);
        this.pauseButton.setAttribute('aria-label', this.paused
          ? this.pauseButton.dataset.playLabel
          : this.pauseButton.dataset.pauseLabel);
      }

      syncPlayback() {
        window.clearTimeout(this.timer);
        this.timer = null;
        if (!this.isConnected || !this.mobileQuery.matches || this.motionQuery.matches
          || this.paused || this.focusPaused || !this.inView || document.hidden) return;
        this.timer = window.setTimeout(() => {
          this.currentIndex = (this.currentIndex + 1) % this.slides.length;
          this.updateSlides();
          this.syncPlayback();
        }, 3500);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
